import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-config-policy-s-add-btn",
  "use": "app-icon-config-policy-s-add-btn-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-config-policy-s-add-btn\"><path d=\"M8.5 1a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm0 1a6.5 6.5 0 100 13 6.5 6.5 0 000-13zm0 2.5A.5.5 0 019 5v3h3a.5.5 0 110 1H9v3a.5.5 0 11-1 0V9H5a.5.5 0 010-1h3V5a.5.5 0 01.5-.5z\" fill=\"#2673E5\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol